import { render, staticRenderFns } from "./blogs4.vue?vue&type=template&id=fb056476&scoped=true"
import script from "./blogs4.vue?vue&type=script&lang=js"
export * from "./blogs4.vue?vue&type=script&lang=js"
import style0 from "./blogs4.vue?vue&type=style&index=0&id=fb056476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb056476",
  null
  
)

export default component.exports